import { render } from "./Start.vue?vue&type=template&id=91e3533a"
import script from "./Start.vue?vue&type=script&lang=js"
export * from "./Start.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Start.vue?vue&type=style&index=0&id=91e3533a&lang=scss&module=true"
cssModules["$style"] = style0
import "./Start.vue?vue&type=style&index=1&id=91e3533a&lang=css"

import exportComponent from "/home/r/Desktop/ev-switch-global/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__